import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { QUOTE_BID_STATUS_DICTIONARY } from '../../config/settings/constants'
import { getCausesInadmissibility, postDeclarationInadmissibility } from '../../services/quoteSummary'
import { onUpdatedStatusQuoteBid } from '../QuoteBasicInformation/QuoteBasicInformation.actions'

export const SHOW_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG = 'SHOW_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG'
export const onShowDeclarationInadmissibilityQuoteDialog = makeActionCreator(
  SHOW_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG,
  'payload'
)

export const CLOSE_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG = 'CLOSE_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG'
export const onCloseDeclarationInadmissibilityQuoteDialog = makeActionCreator(
  CLOSE_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG,
  {}
)

export const GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG = 'GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG'
export const GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG_SUCCESS =
  'GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG_SUCCESS'
export const GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG_ERROR =
  'GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG_ERROR'

export const onGetCausesDeclarationInadmissibilityQuoteDialog = makeActionCreator(
  GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG
)
export const onGetCausesDeclarationInadmissibilityQuoteDialogSuccess = makeActionCreator(
  GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG_SUCCESS,
  'payload'
)
export const onGetCausesDeclarationInadmissibilityQuoteDialogError = makeActionCreator(
  GET_CAUSES_DECLARATION_INADMISSIBILITY_QUOTE_DIALOG_ERROR,
  'payload'
)

export const onGetCausesDeclarationInadmissibilityQuoteDialogThunk = () => async dispatch => {
  dispatch(onGetCausesDeclarationInadmissibilityQuoteDialog())

  try {
    const { data } = await getCausesInadmissibility()

    dispatch(
      onGetCausesDeclarationInadmissibilityQuoteDialogSuccess({
        justificationsCriteria: data?.payload.map(cause => {
          return {
            value: cause.id.toString(),
            label: cause.nombre,
            order: cause.id,
            active: cause.activo
          }
        })
      })
    )
  } catch (err) {
    dispatch(onGetCausesDeclarationInadmissibilityQuoteDialogError({ err }))
  }
}

export const DECLARE_INADMISSIBILITY_QUOTE_DIALOG = 'DECLARE_INADMISSIBILITY_QUOTE_DIALOG'
export const DECLARE_INADMISSIBILITY_QUOTE_DIALOG_SUCCESS = 'DECLARE_INADMISSIBILITY_QUOTE_DIALOG_SUCCESS'
export const DECLARE_INADMISSIBILITY_QUOTE_DIALOG_ERROR = 'DECLARE_INADMISSIBILITY_QUOTE_DIALOG_ERROR'

export const onDeclareInadmissibilityQuote = makeActionCreator(DECLARE_INADMISSIBILITY_QUOTE_DIALOG)
export const onDeclareInadmissibilityQuoteSuccess = makeActionCreator(DECLARE_INADMISSIBILITY_QUOTE_DIALOG_SUCCESS)
export const onDeclareInadmissibilityQuoteError = makeActionCreator(DECLARE_INADMISSIBILITY_QUOTE_DIALOG_ERROR)

export const onDeclareInadmissibilityQuoteThunk = payload => async dispatch => {
  dispatch(onDeclareInadmissibilityQuote())

  try {
    await postDeclarationInadmissibility(payload.declaration)

    return batch(() => {
      dispatch(onDeclareInadmissibilityQuoteSuccess())
      dispatch(
        onUpdatedStatusQuoteBid({
          bidId: payload.quoteBidId,
          status: QUOTE_BID_STATUS_DICTIONARY.INADMISSIBILITY,
          inadmissibility: payload.justification
        })
      )
      payload.callback()
    })
  } catch (err) {
    dispatch(onDeclareInadmissibilityQuoteError({ err }))
  }
}
